import axios, {AxiosInstance} from 'axios';
import {config} from '../config';
import {Verify} from '../public/verify';

export class IIUMLuxtagBase {
  private readonly instance: AxiosInstance;

  public constructor() {
    this.instance = axios.create(config);
  }

  public verify() {
    return new Verify(this.instance);
  }

}
